module.exports = __webpack_public_path__ + "static/img/IMG_20240819_195319.cf18b6b2.jpg";